import { Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import SolutionDetail from "@/pages/SolutionDetail";
import ServiceAreas from "@/pages/ServiceAreas";
import StateDetail from "@/pages/StateDetail";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import EducationCenter from "@/pages/EducationCenter";
import EduSearchResults from "@/pages/EduSearchResults";
import CategoryPage from "@/pages/CategoryPage";
import LearningPathPage from "@/pages/LearningPathPage";
import Glossary from "@/pages/Glossary";
import GlossaryTerm from "@/pages/GlossaryTerm";
import ArticleDetail from "@/pages/ArticleDetail";
import MarketCenter from "@/pages/MarketCenter";
import Resources from "@/pages/Resources";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

export default function MarketingLayout() {
  return (
    <SmoothScroll>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/:slug" element={<SolutionDetail />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/service-areas/:stateId" element={<StateDetail />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/:slug" element={<IndustryDetail />} />
          <Route path="/education" element={<EducationCenter />} />
          <Route path="/education/search" element={<EduSearchResults />} />
          <Route path="/education/glossary" element={<Glossary />} />
          <Route path="/education/glossary/:term" element={<GlossaryTerm />} />
          <Route path="/education/category/:categorySlug" element={<CategoryPage />} />
          <Route path="/education/paths/:pathSlug" element={<LearningPathPage />} />
          <Route path="/education/:slug" element={<ArticleDetail />} />
          <Route path="/market-center" element={<MarketCenter />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </SmoothScroll>
  );
}
